import Slider from 'components/slider';

const attractionWrap = document.querySelector('.j-slider-attraction');

if (attractionWrap) {
    const attractionSlider = new Slider();

    attractionSlider.init({
        slider      : attractionWrap,
        dots        : false,
        thumbnails  : false,
        arrow       : true,
        counter     : false,
        modify      : 'bg_transparent',
        slideVisible: 3,
        infinityLoop: true,
        responsive  : {
            0   : 1.1,
            670 : 2,
            960 : 3,
            1280: 3
        }
    });
}
